module.exports = __webpack_public_path__ + "images/icons_v2/mail-outlined-602c4f20.svg";